import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import Chip from '@mui/material/Chip';
import { getPictureCategoryLabel } from './utils/getPictureCategoryLabel';
import { usePictureCategoriesQuery } from './network/pictureCategoriesQuery';
import { AppState } from '../../reducers';
import { Picture } from './objects/picture';

// La prop accepte n'importe quel porteur de picture_category (Picture, PictureForm, objet
// partiel d'une reponse legere) ainsi que null/undefined : les cartes photo du BO manipulent
// des objets de formes tres variables.
type Props = {picture?: Pick<Picture, 'picture_category'> | null};

const PictureCategoryLabel: FC<Props> = ({ picture }) => {
    const current_locale = useSelector((state: AppState) => state.locale.current_locale);
    const { data: categories } = usePictureCategoriesQuery();
    const label = getPictureCategoryLabel(Number(current_locale), picture?.picture_category, categories ?? []);

    if (label === null) {
        return null;
    }

    return <Chip className={ 'ft-picture-categoryLabel' } size={ 'small' } variant={ 'outlined' } label={ label }/>;
};

export default PictureCategoryLabel;
